module.exports = __webpack_public_path__ + "components/rewards/absolutely-snow/static/logo-7e75a697e741d3da6b89f08e317a7b7d.jpg";